export var KNOWN_USER_LOGIN_ERROR = {
    "Incorrect credentials": "error.user.incorrectcredentials",
    "Request failed with status code 403": "error.user.403",
};
export var DEFAULT_USER_LOGON_ERROR = "error.user.retrieve";
